import { IOperatorInfoModel } from "../../interfaces/Login/IOperatorInfoModel";
import { IWorkstationInfoModel } from "../../interfaces/Login/IWorkstationInfoModel";
import { IPayloadWrapper } from "./PayloadWrapper";

export const SET_USER = "automatpacken/user/SET";
export const SET_WORKSTATION = "automatpacken/workstation/SET";
export const CLEAR_LOGIN_STATE = "automatpacken/workstation/CLEAR_LOGIN_STATE";
export const SET_IS_PARTIAL_DELIVERY_ENABLED =
  "automatpacken/workstation/SET_IS_PARTIAL_DELIVERY_ENABLED";

interface SetWorkstation {
  type: typeof SET_WORKSTATION;
  payload: IWorkstationInfoModel;
}

interface SetUser {
  type: typeof SET_USER;
  payload: IOperatorInfoModel;
}

interface ClearLoginState {
  type: typeof CLEAR_LOGIN_STATE;
}

export interface ILoginInfo {   
  operatorName: string;
  operatorID: number;
  rxEnabled: boolean;
  removeSkuAccess: boolean;
  cancelSortBoxAccess: boolean;
  partialDeliveryAccess: boolean;
}

export interface LoginState {
  operatorID: number;
  operatorName: string;
  workstationID: number;
  workstationType: number;
  branchID: number;
  partialDeliveryAccess: boolean;
  autoScaleEnabled: boolean;
  companyID: number;
}

export type LoginStateTypes = SetWorkstation | SetUser | ClearLoginState;
